<div ngModelGroup="comboPrograma-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboPrograma 
                       nome="programa-{{data}}" 
                       [itens]="dados" 
                       itemDescricao="nome"
                       itemId="id"
                       [showDisplayId]="showDisplayId" 
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome do programa"
                       label="Programa"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>

